import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./tile-header-icon.html';
import styles from './tile-header-icon-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            icon: '@'
        },
        template: cssUtil.hashTemplate(template, styles)
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/tiles/tileLayout/HeaderIcon/tileHeaderIcon.js
// module id = 1169
// module chunks = 0